import { EndpointBuilder } from '@reduxjs/toolkit/dist/query/endpointDefinitions';

export default (build: EndpointBuilder<any, any, any>) =>
  build.mutation<Response, Body>({
    query: (body) => ({
      url: `v4/pitch-owner/tournaments/${body.tournamentId}/matches/${body.matchId}/reset-score`,
      method: 'GET',
    }),
  });

interface Body {
  tournamentId: number;
  matchId: number;
}

interface Response {
  data: {
    message: string;
    code: number;
  };
}
